import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { XpoAuthenticationGuard } from '@xpo/ngx-auth';
import { PickupRequestComponent } from './pickup-request/pickup-request.component';
import { ShipmentDetailsComponent } from './shipment-details/shipment-details.component';
import { UpdateShipmentStatusComponent } from './update-shipment-status/update-shipment-status.component';

const routes: Routes = [
  {
    path: 'create-pickup',
    component: PickupRequestComponent,
    canActivate: [XpoAuthenticationGuard],
  },
  {
    path: 'update-pickups',
    component: PickupRequestComponent,
    canActivate: [XpoAuthenticationGuard],
  },
  {
    path: 'edit-pickup/:pickupRequestId/:callNbr',
    component: PickupRequestComponent,
    canActivate: [XpoAuthenticationGuard],
  },
  {
    path: 'shipment-details',
    component: ShipmentDetailsComponent,
    canActivate: [XpoAuthenticationGuard],
  },
  {
    path: 'shipment-details/:shipmentInstId',
    component: ShipmentDetailsComponent,
    canActivate: [XpoAuthenticationGuard],
  },
  {
    path: 'update-shipment-status',
    component: UpdateShipmentStatusComponent,
    canActivate: [XpoAuthenticationGuard],
  },
  { path: '', redirectTo: 'main', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
